import { useEffect } from 'react';
import { parseQuery } from 'utils/helpers.util';
import { showNotification } from 'common/Notification/redux/notification.action';
import useAction from './useAction';
import REASON_CODE from 'constants/cyberSourceErrors';
import { notificationTypes } from 'common/Notification/redux/notification.type';

export const useReasonCode = (queryString: string) => {
  const [showNotificationAction] = useAction(showNotification);

  useEffect(() => {
    const { reason_code: reasonCode } = parseQuery(queryString);
    if (reasonCode) {
      showNotificationAction({
        type: notificationTypes.errorCheckout,
        message: REASON_CODE[reasonCode] || 'Something went wrong',
      });
    }
  }, [queryString, showNotificationAction]);
};

export default useReasonCode;
